<template>
  <div class="l-content-inner">
    <!-- 로그인 & 회원가입 -->
    <div class="p-member-wrap">
      <div class="c-hgroup is-pc">
        <h1 class="c-title-level1">노루페인트 PAINT PRO 회원가입</h1>
      </div>

      <div class="c-process">
        <ol>
          <li>
            <span class="step-circle"></span>
            <span class="text">약관동의</span>
          </li>
          <!-- D: 현재 단계 is-current 추가 -->
          <li class="is-current" aria-current="step">
            <span class="step-circle"></span>
            <span class="text">정보입력</span>
          </li>
          <li>
            <span class="step-circle"></span>
            <span class="text">가입완료</span>
          </li>
        </ol>
      </div>

      <form @submit.prevent action="">
        <div class="c-form-field">
          <label
            class="c-input-label-group"
            :class="{ 'is-danger': isBusiNoNvl }"
          >
            <input
              type="text"
              v-model="busiNo"
              required
              title="사업자 등록번호"
              @keyup="() => (busiNoTouched = true)"
              @blur="() => (busiNoTouched = true)"
            />
            <span class="input-label">사업자 등록번호</span>
          </label>
          <button
            type="button"
            class="c-button type-primary type-small"
            @click="loadKunnr"
            :disabled="isBusiNoInvalid"
          >
            <span>조회</span>
          </button>
        </div>

        <div v-if="kunnr" class="c-table-box">
          <div class="table-head flex-between">
            <div class="col">
              <!-- [20241206] id를 한글로 변경 -->
              <strong class="subject">아이디</strong>
              <!-- // [20241206] id를 한글로 변경 -->
            </div>
            <div class="col">
              <span class="system">
                <b>{{ kunnr.kunnr }}</b>
              </span>
            </div>
          </div>
          <div class="table-body">
            <div class="grid">
              <span class="label">특약점명</span>
              <p class="text">
                <b>{{ kunnr.zbpName }}</b>
              </p>
            </div>
            <div class="grid">
              <span class="label">대표자명</span>
              <p class="text">
                <b>{{ kunnr.j1kfrepre }}</b>
              </p>
            </div>
            <div class="grid">
              <span class="label">유선전화</span>
              <p class="text">
                <b>{{ kunnr.telf1 }}</b>
              </p>
            </div>
            <div class="grid">
              <span class="label">휴대폰번호(대표번호)</span>
              <p class="text">
                <b>{{ kunnr.telf2 }}</b>
              </p>
            </div>
            <!-- 20241206: 추가 -->
            <div class="grid colspan">
              <span class="label">이메일</span>
              <p class="text">
                <b>{{ kunnr.smtpAddr }}</b>
              </p>
            </div>
            <!-- // 20241206: 추가 -->
          </div>
        </div>

        <div v-if="kunnr" class="form-wrap type-large-gap">
          <div class="c-form-field">
            <label
              class="c-input-label-group type-password"
              :class="{ 'is-danger': isPasswordNvl }"
            >
              <input
                v-if="passwordMaskingYn"
                type="password"
                required
                title="비밀번호"
                v-model="form.password"
                maxlength="15"
                @keyup="() => (passwordTouched = true)"
                @blur="() => (passwordTouched = true)"
              />
              <input
                v-if="!passwordMaskingYn"
                type="text"
                required
                title="비밀번호"
                v-model="form.password"
                maxlength="15"
                @keyup="() => (passwordTouched = true)"
                @blur="() => (passwordTouched = true)"
              />
              <span class="input-label">비밀번호</span>
              <span v-show="isPasswordInvalid" class="input-result">
                사용불가
              </span>
              <span v-show="isPasswordEmpty" class="input-helper">
                비밀번호를 입력해 주세요
              </span>
              <span class="input-helper">
                띄어쓰기 없는 영문, 숫자, 특수문자 (!@#$%^*+=-) 포함 8~15자
              </span>

              <button
                type="button"
                class="c-btn-icon btn-eye"
                :class="{ 'is-active': !passwordMaskingYn }"
                @click.prevent="() => (passwordMaskingYn = !passwordMaskingYn)"
              >
                <i class="c-icon icon-eye"></i>
              </button>
              <button
                type="button"
                class="c-btn-icon btn-small-delete"
                @click.prevent="() => (form.password = '')"
              >
                <span class="c-icon icon-small-x"></span>
              </button>
            </label>
          </div>

          <div class="c-form-field">
            <!-- D: 비밀번호 인풋 type-password 추가 -->
            <label
              class="c-input-label-group type-password"
              :class="{ 'is-danger': isPasswordCfmNvl }"
            >
              <input
                v-if="passwordCfmMaskingYn"
                type="password"
                required
                title="비밀번호 확인"
                v-model="form.passwordCfm"
                maxlength="15"
                @keyup="() => (passwordCfmTouched = true)"
                @blur="() => (passwordCfmTouched = true)"
              />
              <input
                v-if="!passwordCfmMaskingYn"
                type="text"
                required
                title="비밀번호 확인"
                v-model="form.passwordCfm"
                maxlength="15"
                @keyup="() => (passwordCfmTouched = true)"
                @blur="() => (passwordCfmTouched = true)"
              />
              <span class="input-label">비밀번호 확인</span>
              <span v-show="isPasswordCfmNotMatched" class="input-result">
                불일치
              </span>
              <span v-show="isPasswordCfmEmpty" class="input-helper">
                비밀번호 확인을 입력해 주세요
              </span>
              <button
                type="button"
                class="c-btn-icon btn-eye"
                :class="{ 'is-active': !passwordCfmMaskingYn }"
                @click.prevent="
                  () => (passwordCfmMaskingYn = !passwordCfmMaskingYn)
                "
              >
                <i class="c-icon icon-eye"></i>
              </button>
              <button
                type="button"
                class="c-btn-icon btn-small-delete"
                @click.prevent="() => (form.passwordCfm = '')"
              >
                <span class="c-icon icon-small-x"></span>
              </button>
            </label>
          </div>
          <!-- 20241206: 이메일 필드 삭제 // -->
        </div>

        <div class="c-btn-area">
          <button
            type="button"
            class="c-button type-secondary"
            @click="$emit('back')"
          >
            <span>이전단계</span>
          </button>
          <button
            type="button"
            class="c-button type-primary"
            :disabled="
              !passwordTouched ||
              !passwordCfmTouched ||
              isPasswordNvl ||
              isPasswordCfmNvl
            "
            @click.prevent="submit"
          >
            <span>회원가입</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup name="join_RegisterForm">
import { api } from "@/plugins/api";
import { inject, ref, defineEmits, onMounted, computed } from "vue";
import Utils from "@/js/utils";
import * as cmUtil from "@/utils/cmUtil";

const emits = defineEmits(["next", "back"]);
const url = inject("url_prefix");

const form = ref({
  password: "",
  passwordCfm: "",
});

const passwordTouched = ref(false);
const passwordCfmTouched = ref(false);

const passwordMaskingYn = ref(true);
const passwordCfmMaskingYn = ref(true);

const busiNo = ref("");

const busiNoTouched = ref(false);
const kunnr = ref(null);

onMounted(() => {});

const isBusiNoNvl = computed(() => {
  return busiNoTouched.value && isBusiNoInvalid.value;
});

const isBusiNoInvalid = computed(() => {
  return Utils.isBlank(busiNo.value);
});

const isPasswordNvl = computed(() => {
  return isPasswordEmpty.value || isPasswordInvalid.value;
});

const isPasswordEmpty = computed(() => {
  return passwordTouched.value && Utils.isBlank(form.value.password);
});

const isPasswordInvalid = computed(() => {
  return passwordTouched.value && !Utils.isValidPassword(form.value.password);
});

const isPasswordCfmNvl = computed(() => {
  return isPasswordCfmEmpty.value || isPasswordCfmNotMatched.value;
});

const isPasswordCfmEmpty = computed(() => {
  return passwordCfmTouched.value && Utils.isBlank(form.value.passwordCfm);
});

const isPasswordCfmNotMatched = computed(() => {
  return (
    passwordTouched.value && form.value.password !== form.value.passwordCfm
  );
});

const loadKunnr = async () => {
  const res = await api.get(
    `${url}/register/kunnr-by-busi-no/${busiNo.value.trim()}`
  );

  if (res.error) {
    if (res.error.status === "404") {
      cmUtil.alert(
        "사업자번호와 일치하는 정보가 없습니다. <br/>문의: 담당 영업사원"
      );
    } else if (res.error.status === "409") {
      cmUtil.alert(
        "이미 가입한 회원 사업자번호입니다. <br/>문의: 담당 영업사원"
      );
    } else {
      cmUtil.alert("오류가 발생하였습니다. <br/>문의: 담당 영업사원");
    }

    return;
  }

  kunnr.value = res.data;
};

const submit = async () => {
  const payload = {
    busiNo: kunnr.value.stcd2.trim(),
    password: form.value.password.trim(),
  };

  const res = await api.post(`${url}/register/join`, payload);

  if (res.error) {
    if (res.error.status === "404") {
      cmUtil.alert(
        "사업자번호와 일치하는 정보가 없습니다. <br/>문의: 담당 영업사원"
      );
    } else if (res.error.status === "409") {
      cmUtil.alert(
        "이미 가입한 회원 사업자번호입니다. <br/>문의: 담당 영업사원"
      );
    } else {
      cmUtil.alert("오류가 발생하였습니다. <br/>문의: 담당 영업사원");
    }

    return;
  }

  emits("next");
};
</script>
